var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOpenFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13808",
    "data-name": "Group 13808",
    xmlns: "http://www.w3.org/2000/svg",
    width: 116.062,
    height: 87,
    viewBox: "0 0 116.062 87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11199",
    "data-name": "Path 11199",
    d: "M9,19H37.308L45.8,26.016h65.108V41.452h14.154L110.908,106H9ZM121.549,44.258l-96.078-.005L13.246,103.194h95.38ZM11.831,21.806l0,74.509L23.154,41.452h84.923V28.823h-63.3l-8.492-7.016Z",
    transform: "translate(-9 -19)",
    fill: "var(--secondaryColor)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenFileIcon);
export default __webpack_public_path__ + "static/media/open-file-icon.de28017862647369a5cdffeab28805fc.svg";
export { ForwardRef as ReactComponent };